import apis from "../../config/apis.json";
import { getAccessToken } from "../msal";
import { IPublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import {
  IGetUserRequest,
  IGetUsersRequest,
  IUser,
} from "./interfaces";
import { IResponse } from "lib/common/interfaces";
import { QueryString } from "lib/common/query-string";

/**
 * Retrieves the user from the security service, using the ID specified in the `request`.
 *
 * @param instance msal instance
 * @param request IGetUserRequest object containing the Ixico User ID to retrieve
 */
export async function getUser(instance: IPublicClientApplication, request: IGetUserRequest): Promise<IResponse<IUser> | undefined> {
  if (!request.userId) {
    return;
  }

  const { scope, baseUrl } = apis.security;

  const requestUrl = `${baseUrl}/users/${request.userId}`;
  const accessToken = await getAccessToken(instance, scope);

  const result = await axios.get(
    requestUrl, {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      }
    });

  const etag = result.headers["etag"];

  return {
    headers: {
      etag
    },
    data: result.data,
  };
}

/**
 * Retrieves a list of users.
 *
 * @param instance The msal instance.
 * @param request The request details.
 * @returns The retrieved users.
 */
export async function getUsers(instance: IPublicClientApplication, request: IGetUsersRequest): Promise<IUser[]> {
  const { scope, baseUrl } = apis.security;

  const queryString = QueryString.from(request.queryParams);
  const requestUrl = `${baseUrl}/users${queryString}`;
  const accessToken = await getAccessToken(instance, scope);

  const result = await axios.get(
    requestUrl, {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      }
    });

  return result.data;
}
